const conf = {
  "VUE_APP_SERVER_URL": process.env.VUE_APP_SERVER_URL
};
export default conf;